import { ReactNode } from "react";

export function AdminSectionHeader({
  title,
  description,
  right,
}: {
  title: string;
  description?: ReactNode;
  right?: ReactNode;
}) {
  return (
    <div className="admin-section-header">
      <div>
        <h2 className="admin-section-title">{title}</h2>
        {description ? <p className="admin-section-subtitle">{description}</p> : null}
      </div>
      {right ? <div className="admin-section-header-right">{right}</div> : null}
    </div>
  );
}

